import { useCallback, useState } from 'react';
import { doPOSTJSON } from '../api';

export function LoginPage(params: {onLoggedIn: (email: string) => void}) {
	let [email, setEmail] = useState("");
	let [emailSent, setEmailSent] = useState(false);
	let [code, setCode] = useState("");

	const onLoginInit = useCallback(async () => {
		try {
			await doPOSTJSON(`/login/init`, {email: email});
			setEmailSent(true);
		} catch (e) {
			alert(e);
		}
	}, [email, code]);
	const onLoginVerify = useCallback(async () => {
		try {
			await doPOSTJSON(`/login/verify`, {email: email, code: code});
			params.onLoggedIn(email);
		} catch (e) {
			alert(e);
		}
	}, [email, code]);

	return <>
		{!emailSent && <>
			Email:<br/>
			<input type="text" value={email} onChange={e => setEmail(e.target.value)} />
		</>}

		{!!emailSent && <>
			Code:<br/>
			<input type="text" value={code} onChange={e => setCode(e.target.value)} />
		</>}

		<br/><br/>
		<button onClick={emailSent ? onLoginVerify : onLoginInit}>Send</button>
	</>;
}